var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_calendar",
    d: "M2,23a2,2,0,0,1-2-2L.01,4A1.991,1.991,0,0,1,2,2H3V0H5V2H21V0h2V2h1a2.006,2.006,0,0,1,2,2V21a2.006,2.006,0,0,1-2,2Zm0-2H24V6H2Zm9.24-3.679v-3h3v3Zm-7,0v-3h3v3Zm14-5v-3h3v3Zm-7,0v-3h3v3Zm-7,0v-3h3v3Z",
    fill: "#0000b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.987390ccf8f37efd166094164ebecc81.svg";
export { ForwardRef as ReactComponent };